module.exports = __webpack_public_path__ + "static/media/instagram.5f1a9de1.png";